import default_profile_image from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { createColumnHelper } from '@tanstack/react-table';
import { BlobImage } from '../../../utils/blobImage';

export const prepareClientUserData = (apiResponse, onToggleStatus, onNameClick) => {
    const users = apiResponse?.users || [];
    const columnHelper = createColumnHelper();

    const rows = users.map((u) => ({
        username: u.username || '',
        name: u.name || '',
        designation: u.designation || '',
        phoneNumber: u.phoneNumber || '',
        emailId: u.emailId || '',
        clientRole: u.clientRole || '',
        userStatus: u.userStatus || '',
        dpPath: u.dpPath || null,
    }));

    const columns = [
        columnHelper.accessor((row) => row.name, {
            id: 'nameColumn',
            header: 'Name',
            cell: (info) => {
                const row = info.row.original;
                return (
                    <div
                        style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: "pointer" }}
                        onClick={() => onNameClick(row.username)}
                    >
                        <div
                            style={{
                                width: '38px',
                                height: '38px',
                                borderRadius: '50%',
                                overflow: 'hidden'
                            }}
                        >
                            <BlobImage imageUrl={row.dpPath} />
                        </div>

                        <div style={{ fontWeight: 500, color: "#F35824", textDecoration: "none" }}>
                            {row.name || '-'}
                        </div>
                    </div>
                );
            }

        }),
        columnHelper.accessor((row) => row.phoneNumber, {
            id: 'phoneNumber',
            header: 'Contact No.',
            cell: (info) => info.getValue() || '-',
        }),
        columnHelper.accessor((row) => row.emailId, {
            id: 'emailId',
            header: 'Email',
            cell: (info) => info.getValue() || '-',
        }),
        columnHelper.accessor((row) => row.designation, {
            id: 'designation',
            header: 'Role',
            cell: (info) => info.getValue() || '-',
        }),
        columnHelper.accessor((row) => row.clientRole, {
            id: 'clientRole',
            header: 'Client Role',
            cell: (info) => info.getValue() || '-',
        }),
        columnHelper.accessor(row => row.userStatus, {
            id: 'userStatus',
            header: 'User Status',
            cell: info => info.getValue() || '-',
        }),
        columnHelper.accessor(row => row.username, {
            id: 'action',
            header: 'Action',
            cell: (info) => {
                const row = info.row.original;
                const status = row.userStatus;
                const isPrimary = row.clientRole === "PRIMARY";

                return (
                    <button
                        style={{
                            padding: "6px 12px",
                            backgroundColor: isPrimary
                                ? "#9e9e9e"
                                : status === "ACTIVE"
                                    ? "#d9534f"
                                    : "#5cb85c",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: isPrimary ? "not-allowed" : "pointer",
                            opacity: isPrimary ? 0.6 : 1,
                        }}
                        disabled={isPrimary}
                        onClick={() => {
                            if (!isPrimary) {
                                onToggleStatus(row.username, status);
                            }
                        }}
                    >
                        {isPrimary
                            ? "Deactivate"
                            : status === "ACTIVE"
                                ? "Deactivate"
                                : "Activate"}
                    </button>
                );
            },
        }),

    ];

    return { columns, data: rows };
};
